export const REMARK_TOOLTIP_ON_LABEL_KEY = 'remarkTooltipOnLabel'

export function isRemarkTooltipOnLabel(props: any) {
  return !!(props?.remark && props?.remarkToolTipFlag && props?.showLabel !== false)
}
